import React, { useEffect, useRef, useState } from "react";
import PaulPFP from "../../../assets/blog/paul.png";
import AyuPFP from "../../../assets/blog/ayu.png";
import AnuPFP from "../../../assets/blog/anu.png";

const teamMembers = [
  {
    key: "paul",
    shortName: "PAUL",
    fullName: "Paul Frederick David Walsh",
    role: "Founder",
    image: PaulPFP,
  },
  {
    key: "ayu",
    shortName: "AYU",
    fullName: "Ayu Suryo Prayogo",
    role: "Teacher & Coach",
    image: AyuPFP,
  },
  {
    key: "anu",
    shortName: "ANU",
    fullName: "Anurag Sunil",
    role: "Mobile Specialist",
    image: AnuPFP,
  },
];


const roadmapMilestones = [
  {
    id: "discord-guild",
    order: 1,
    label: ["Discord", "Guild"],
    title: "Discord Guild",
    status: "completed",
    tagline: "Where the Pogforts community began.",
    brief: [
      "Pogforts began as a Discord community with big ideas. Built around social interaction, competition, creativity and shared experiences. The Discord Guild established the community foundation from which the wider Pogforts ecosystem developed, providing the environment for members, houses, games, events, voice interaction and the systems that would follow.",
    ],
  },
  {
    id: "economy",
    order: 2,
    label: ["Economy"],
    title: "Economy",
    status: "completed",
    tagline: "Giving participation value, progression and consequence.",
    brief: [
      "Pogforts developed its own virtual economy and progression systems, allowing community participation to connect with balances, rewards, rankings and other interactive mechanics. Rather than activity existing purely as meaningless statistics, the economy gives actions within Pogforts a wider purpose and creates the foundations for game systems, progression and competition.",
    ],
  },
  {
    id: "discord-bot",
    order: 3,
    label: ["Discord", "Bot"],
    title: "Discord Bot — Magical Sorting Bat",
    status: "completed",
    tagline: "Centralising automation around the community.",
    brief: [
      "Magical Sorting Bat, commonly known as MSB or simply The Bat, was developed as Pogforts' central Discord automation system. Instead of depending upon an excessive collection of disconnected single-purpose bots, MSB brings community functions, progression, games, voice systems, moderation-supporting features and other functionality into one evolving platform.",
    ],
  },
  {
    id: "web-app",
    order: 4,
    label: ["Web", "App"],
    title: "Web App",
    status: "completed",
    tagline: "Taking Pogforts beyond the boundaries of Discord.",
    brief: [
      "Pogforts.uk expanded the project from a Discord community into its own connected web application. The web platform provides account functionality, community information, leaderboards, game interfaces, authenticated services, MSB integration, legal information and other systems that allow Pogforts to develop beyond the limitations of any single third-party platform.",
    ],
  },
  {
    id: "games",
    order: 5,
    label: ["Games"],
    title: "Games",
    status: "completed",
    tagline: "Turning community participation into interactive experience.",
    brief: [
      "Pogforts expanded its community systems through original games and competitive experiences, including Pogforts: Murder Mystery Magic and the wider systems surrounding houses, progression, rankings, abilities and social competition. This further includes pogforts.uk exclusive casino games. Our games provide members with reasons to interact, cooperate, compete and build identity inside the community rather than relying upon forced activity to make the platform appear busy.",
    ],
  },
  {
    id: "custom-ai",
    order: 6,
    label: ["Custom", "AI"],
    title: "Custom AI — Bat AI",
    status: "completed",
    tagline: "Building intelligence around Pogforts itself.",
    brief: [
      "Pogforts introduced its own public-facing artificial-intelligence layer through Bat AI, designed around the Pogforts ecosystem rather than presenting members with another disconnected external tool. Bat AI provides an expandable intelligence layer capable of supporting search, Pogforts knowledge and future intelligent services while maintaining a provider-agnostic architecture that can evolve as the underlying technology changes.",
    ],
  },
  {
    id: "alpha-testing",
    order: 7,
    label: ["Alpha", "Testing"],
    title: "Alpha Testing",
    status: "current",
    tagline: "Testing the connected ecosystem against reality.",
    brief: [
      "Pogforts has reached the stage where its major foundations are no longer isolated concepts. Community, economy, automation, web systems, games and intelligence are increasingly operating as parts of one wider ecosystem. This objective is to test those systems, identify weaknesses, improve integration, refine the user experience and strengthen the platform before expanding access further.",
    ],
  },
  {
    id: "open-beta",
    order: 8,
    label: ["Open", "Beta"],
    title: "Open Beta",
    status: "future",
    tagline: "Opening Pogforts development to the wider population.",
    brief: [
      "Open Beta represents the point at which a wider audience can participate in testing and experiencing the developing Pogforts ecosystem. This stage will allow greater real-world usage, broader feedback and increased pressure on the systems we have created, helping us identify what performs successfully at greater scale and what still needs to evolve.",
    ],
  },
  {
    id: "services",
    order: 9,
    label: ["Services"],
    title: "Services",
    status: "future",
    tagline: "Turning Pogforts capability into useful external services.",
    brief: [
      "As Pogforts develops its own technology, community systems, automation and digital infrastructure, the next stage is to identify where those capabilities can provide useful services beyond their original internal purpose. The Services milestone represents the controlled expansion of proven Pogforts capabilities into services capable of providing value to individuals, communities or organisations outside the original Pogforts environment.",
    ],
  },
  {
    id: "partners",
    order: 10,
    label: ["Partners"],
    title: "Partners",
    status: "future",
    tagline: "Growing through collaboration without losing identity.",
    brief: [
      "Pogforts does not need to build every opportunity entirely alone. The Partners milestone represents establishing relationships with suitable people, organisations and services where collaboration can increase capability, reach or community value. Any partnership should strengthen the Pogforts mission rather than dilute it, with responsibilities, ownership and third-party involvement remaining clearly identifiable.",
    ],
  },
  {
    id: "currency",
    order: 11,
    label: ["Currency"],
    title: "Currency",
    status: "future",
    tagline: "Establishing Pogforts currency as an official crypto coin.",
    brief: [
      "This is the point where Pogforts pushes its own cryptocurrency based on the POG that already internally funds our ecosystem, allowing our current currency to break free from its shell and go beyond its existing limitations. The established currency will be developed with the wider purpose of creating new forms of economic participation and exploring solutions to problems associated with financial hardship.",
    ],
  },
  {
    id: "further-success",
    order: 12,
    label: ["Further", "Success"],
    title: "Further Success",
    status: "future",
    tagline: "The destination keeps moving.",
    brief: [
      "Pogforts is built around the understanding that technology, communities, opportunities and problems continue to evolve. Reaching one objective therefore creates the foundation for discovering another. This final milestone does not represent an ending. It represents our intention to continue observing, creating, adapting and progressing beyond the limits of the roadmap we can currently see. The Roadmap ends here. The journey does not.",
    ],
  },
];
const About = () => {
  const [openProblem, setOpenProblem] = useState(null);
  const [openLivingStatement, setOpenLivingStatement] = useState(null);
  const [activeTeamMember, setActiveTeamMember] = useState(null);
  const [activeRoadmapMilestone, setActiveRoadmapMilestone] = useState(null);
  const [roadmapScale, setRoadmapScale] = useState(1);
  const [roadmapScrollMode, setRoadmapScrollMode] = useState(false);
  const [roadmapEdgePadding, setRoadmapEdgePadding] = useState(0);
  const [roadmapJourneyActive, setRoadmapJourneyActive] = useState(false);
  const [roadmapJourneyComplete, setRoadmapJourneyComplete] = useState(false);
  const [roadmapJourneyReachedIndex, setRoadmapJourneyReachedIndex] = useState(-1);
  const [roadmapJourneyProgressPercent, setRoadmapJourneyProgressPercent] = useState(0);
  const [roadmapWaitVisible, setRoadmapWaitVisible] = useState(false);

  const roadmapSectionRef = useRef(null);
  const roadmapViewportRef = useRef(null);
  const roadmapCurrentRef = useRef(null);
  const roadmapMilestoneRefs = useRef([]);
  const roadmapModalRef = useRef(null);
  const roadmapTriggerRef = useRef(null);
  const roadmapGestureRef = useRef({ startX: 0, startScrollLeft: 0, moved: false });
  const roadmapLastScrollAtRef = useRef(0);
  const roadmapWasScrollModeRef = useRef(false);
  const roadmapScrollModeValueRef = useRef(false);
  const roadmapJourneyStartedRef = useRef(false);
  const roadmapJourneyTimersRef = useRef([]);
  const roadmapWaitTimerRef = useRef(null);

  const ROADMAP_DESIGN_WIDTH = 1180;
  const ROADMAP_MIN_SCALE = 0.72;
  const ROADMAP_SWIPE_THRESHOLD = 10;
  const ROADMAP_JOURNEY_START_DELAY = 220;
  const ROADMAP_JOURNEY_SEGMENT_DURATION = 650;
  const ROADMAP_JOURNEY_NODE_HOLD = 220;
  const ROADMAP_WAIT_FADE_DURATION = 300;

  const currentRoadmapIndex = roadmapMilestones.findIndex((milestone) => milestone.status === "current");
  const roadmapProgressPercent = currentRoadmapIndex <= 0
    ? 0
    : (currentRoadmapIndex / (roadmapMilestones.length - 1)) * 100;

  const closeRoadmapModal = () => {
    setActiveRoadmapMilestone(null);
  };

  const clearRoadmapJourneyTimers = () => {
    roadmapJourneyTimersRef.current.forEach((timerId) => window.clearTimeout(timerId));
    roadmapJourneyTimersRef.current = [];

    if (roadmapWaitTimerRef.current) {
      window.clearTimeout(roadmapWaitTimerRef.current);
      roadmapWaitTimerRef.current = null;
    }
  };

  const scheduleRoadmapJourneyStep = (callback, delay) => {
    const timerId = window.setTimeout(callback, delay);
    roadmapJourneyTimersRef.current.push(timerId);
    return timerId;
  };

  const centerRoadmapMilestone = (index, behavior = "smooth") => {
    const viewport = roadmapViewportRef.current;
    const milestoneNode = roadmapMilestoneRefs.current[index];
    if (!viewport || !milestoneNode) return;

    const viewportRect = viewport.getBoundingClientRect();
    const nodeRect = milestoneNode.getBoundingClientRect();
    const nodeCentreWithinViewport =
      viewport.scrollLeft +
      (nodeRect.left + nodeRect.width / 2) -
      (viewportRect.left + viewport.clientWidth / 2);
    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const targetLeft = Math.max(0, Math.min(nodeCentreWithinViewport, maxScroll));

    if (typeof viewport.scrollTo === "function") {
      viewport.scrollTo({ left: targetLeft, behavior });
    } else {
      viewport.scrollLeft = targetLeft;
    }
  };

  const showRoadmapPleaseWait = () => {
    if (roadmapJourneyComplete) return;

    setRoadmapWaitVisible(true);

    if (roadmapWaitTimerRef.current) {
      window.clearTimeout(roadmapWaitTimerRef.current);
    }

    roadmapWaitTimerRef.current = window.setTimeout(() => {
      setRoadmapWaitVisible(false);
      roadmapWaitTimerRef.current = null;
    }, 1000);
  };

  useEffect(() => {
    const viewport = roadmapViewportRef.current;
    if (!viewport) return undefined;

    const updateRoadmapMode = () => {
      const availableWidth = viewport.clientWidth;
      if (!availableWidth) return;

      const fitScale = Math.min(1, availableWidth / ROADMAP_DESIGN_WIDTH);
      const nextScrollMode = fitScale < ROADMAP_MIN_SCALE;
      const nextScale = nextScrollMode ? ROADMAP_MIN_SCALE : fitScale;
      const roadmapContentWidth = ROADMAP_DESIGN_WIDTH * nextScale;
      const milestoneCellWidth = roadmapContentWidth / roadmapMilestones.length;
      const nextEdgePadding = nextScrollMode
        ? Math.max(0, availableWidth / 2 - milestoneCellWidth / 2)
        : 0;

      roadmapScrollModeValueRef.current = nextScrollMode;
      setRoadmapScrollMode(nextScrollMode);
      setRoadmapScale(nextScale);
      setRoadmapEdgePadding(nextEdgePadding);
    };

    updateRoadmapMode();

    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateRoadmapMode)
      : null;

    if (observer) observer.observe(viewport);
    window.addEventListener("resize", updateRoadmapMode);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", updateRoadmapMode);
    };
  }, []);

  useEffect(() => {
    const viewport = roadmapViewportRef.current;
    if (!viewport) return;

    const enteredScrollMode = roadmapScrollMode && !roadmapWasScrollModeRef.current;

    if (enteredScrollMode) {
      requestAnimationFrame(() => {
        if (!roadmapJourneyStartedRef.current) {
          viewport.scrollLeft = 0;
        } else if (roadmapJourneyComplete) {
          centerRoadmapMilestone(currentRoadmapIndex, "auto");
        }
      });
    }

    roadmapWasScrollModeRef.current = roadmapScrollMode;
  }, [roadmapScrollMode, roadmapScale, roadmapEdgePadding, roadmapJourneyComplete, currentRoadmapIndex]);

  useEffect(() => {
    const section = roadmapSectionRef.current;
    if (!section) return undefined;

    const startRoadmapJourney = () => {
      if (roadmapJourneyStartedRef.current) return;
      roadmapJourneyStartedRef.current = true;

      clearRoadmapJourneyTimers();
      setRoadmapJourneyComplete(false);
      setRoadmapJourneyActive(true);
      setRoadmapJourneyReachedIndex(-1);
      setRoadmapJourneyProgressPercent(0);
      setRoadmapWaitVisible(false);

      const viewport = roadmapViewportRef.current;
      const reduceMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (roadmapScrollModeValueRef.current && viewport) {
        viewport.scrollLeft = 0;
      }

      if (reduceMotion) {
        requestAnimationFrame(() => {
          setRoadmapJourneyReachedIndex(currentRoadmapIndex);
          setRoadmapJourneyProgressPercent(roadmapProgressPercent);

          if (roadmapScrollModeValueRef.current) {
            centerRoadmapMilestone(currentRoadmapIndex, "auto");
          }

          setRoadmapJourneyActive(false);
          setRoadmapJourneyComplete(true);
        });
        return;
      }

      let elapsed = ROADMAP_JOURNEY_START_DELAY;

      scheduleRoadmapJourneyStep(() => {
        setRoadmapJourneyReachedIndex(0);

        if (roadmapScrollModeValueRef.current) {
          centerRoadmapMilestone(0, "smooth");
        }
      }, elapsed);

      for (let index = 1; index <= currentRoadmapIndex; index += 1) {
        elapsed += ROADMAP_JOURNEY_NODE_HOLD;

        const progressPercent =
          (index / (roadmapMilestones.length - 1)) * 100;

        scheduleRoadmapJourneyStep(() => {
          setRoadmapJourneyProgressPercent(progressPercent);

          if (roadmapScrollModeValueRef.current) {
            centerRoadmapMilestone(index, "smooth");
          }
        }, elapsed);

        elapsed += ROADMAP_JOURNEY_SEGMENT_DURATION;

        scheduleRoadmapJourneyStep(() => {
          setRoadmapJourneyReachedIndex(index);
        }, elapsed);
      }

      elapsed += ROADMAP_JOURNEY_NODE_HOLD;

      scheduleRoadmapJourneyStep(() => {
        if (roadmapWaitTimerRef.current) {
          window.clearTimeout(roadmapWaitTimerRef.current);
          roadmapWaitTimerRef.current = null;
        }
        setRoadmapWaitVisible(false);
      }, elapsed);

      elapsed += ROADMAP_WAIT_FADE_DURATION;

      scheduleRoadmapJourneyStep(() => {
        setRoadmapJourneyProgressPercent(roadmapProgressPercent);
        setRoadmapJourneyActive(false);
        setRoadmapJourneyComplete(true);
      }, elapsed);
    };

    const observer =
      typeof IntersectionObserver !== "undefined"
        ? new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (entry?.isIntersecting) {
                startRoadmapJourney();
                observer.disconnect();
              }
            },
            {
              threshold: 0.22,
              rootMargin: "0px 0px -8% 0px",
            }
          )
        : null;

    if (observer) {
      observer.observe(section);
    } else {
      startRoadmapJourney();
    }

    return () => {
      if (observer) observer.disconnect();
      clearRoadmapJourneyTimers();
      roadmapJourneyStartedRef.current = false;
    };
  }, [currentRoadmapIndex, roadmapProgressPercent]);

  useEffect(() => {
    if (!activeRoadmapMilestone) return undefined;

    const modal = roadmapModalRef.current;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const focusableSelector =
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    requestAnimationFrame(() => {
      const firstFocusable = modal?.querySelector(focusableSelector);
      if (firstFocusable) firstFocusable.focus();
      else if (modal) modal.focus();
    });

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeRoadmapModal();
        return;
      }

      if (event.key !== "Tab" || !modal) return;

      const focusable = Array.from(modal.querySelectorAll(focusableSelector));
      if (!focusable.length) {
        event.preventDefault();
        modal.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
      requestAnimationFrame(() => roadmapTriggerRef.current?.focus());
    };
  }, [activeRoadmapMilestone]);

  return (
    <div className="about-page">
      <h1 className="about-centred-heading">About Pogforts</h1>
      <p>
        Known as the world's most dangerous Discord, Pogforts is an independent online community, web application and Discord ecosystem built around social interaction,
        competitive gameplay, creative participation and original digital experiences. Founded in the United Kingdom, Pogforts is built by everyday people who refuse to compromise.
      </p>
      <p>
        Pogforts services include pogforts.uk, the Pogforts Discord server, the Magical Sorting Bat Discord bot ("MSB"), Pogforts: Murder Mystery Magic, community games,
        leaderboards, virtual progression systems, authenticated account features, public events, creative projects, social campaigns and other related services developed
        as part of the wider Pogforts collective. All of this combined makes Pogforts the world's most dangerous Discord.
      </p>

      <section className="about-team-section" aria-labelledby="about-team-title">
        <h1 id="about-team-title">OUR TEAM</h1>

        <div className="about-team-grid">
          {teamMembers.map((member) => (
            <button
              key={member.key}
              type="button"
              className="about-team-member"
              onClick={() => setActiveTeamMember(member)}
              aria-label={`Open ${member.fullName} profile`}
            >
              <span className="about-team-avatar">
                <img src={member.image} alt={member.fullName} />
              </span>
              <span className="about-team-name">{member.shortName}</span>
            </button>
          ))}
        </div>

        <div className="about-team-philosophy">
          <p>
            The landscape may change; but so do we. Our strength is being dynamic on a constantly evolving attack surface.
          </p>
          <p className="about-team-motto">“Create it, adapt it, dynamic.”</p>
        </div>
      </section>

      {activeTeamMember && (
        <div
          className="about-team-modal-overlay"
          role="presentation"
          onClick={() => setActiveTeamMember(null)}
        >
          <div
            className="about-team-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="about-team-modal-name"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="about-team-modal-avatar">
              <img src={activeTeamMember.image} alt={activeTeamMember.fullName} />
            </div>

            <div className="about-team-modal-kicker">POGFORTS TEAM</div>
            <h2 id="about-team-modal-name">{activeTeamMember.fullName}</h2>
            <div className="about-team-modal-role">{activeTeamMember.role}</div>

            <button
              type="button"
              className="about-team-modal-close"
              onClick={() => setActiveTeamMember(null)}
            >
              CLOSE
            </button>
          </div>
        </div>
      )}

      <section className="about-problems-panel">
        <h1>The Problems</h1>
        <p>
          For those who walk through society without their eyes closed, a single human life will no doubt experience a multitude of problems within the systems and with the people they engage with.
          Sometimes few, sometimes many, ranging from small to large in their effects. We have highlighted and elaborated on those found throughout our own navigations that we deem critical. But if you
          choose to read on, please keep in mind that we do not promote hate towards any groups or individuals. Our purpose is contributing towards solutions and competing against the opposition.
       </p>

        <div className="about-problems-tree">
          <details
            className="about-problem-node"
            open={openProblem === "double-standard-epidemic"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("double-standard-epidemic");
              }
            }}
          >
            <summary>Double Standard Epidemic</summary>
            <div className="about-problem-content">
              <p>
                After testing hordes of different Discord servers, you conclude that many of them appear not to actually care about their members. A common theme is an overshadowing element of fake
                popularity: server owners and moderators whose priority appears to be using any means available to bloat member counts and create a false appearance of success. They usually create a mediocre
                server, add it to the Disboard search index, and then treat the new people who join through those advertisements as pestilence.
              </p>
              <p>
                Meanwhile, owners lord over the populace like deluded 16th-century monarchs, with moderators acting more like common court jesters. Refuse to accept this narrative and you immediately become
                their problem. You are tagged and flagged as a troublemaker. You are now an outcast, an outlaw, a renegade inside environments that force you to follow the rules of administrators, moderators
                and e-girls surrounded by flocks of simps, even though those same people often do not follow the rules themselves.
              </p>
              <p>
                Therefore, double standards become your enemy. This is a massive problem not only within the digital world, but within the physical world too. You may be smart enough to understand that the
                digital world is created, operated and inhabited by real-world people, making both the digital and physical worlds one and the same. Ordinary people are expected to respect systems and rules
                enforced by individuals who frequently exempt themselves from those very same standards.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "online-management-issues"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("online-management-issues");
              }
            }}
          >
            <summary>Online Management Issues</summary>
            <div className="about-problem-content">
              <p>
                You notice that most owners bring very little value to their online platforms, creating just another “chill” place to waste your time. You are baited into being active, yet your activity holds
                no weight and ultimately means absolutely nothing to anyone. Administrators can force text activity so heavily that members begin responding with nothing more than single-word responses,
                making conversations feel as though you are talking to poorly trained robots.
              </p>
              <p>
                This removes genuine human connection, makes meaningful socialising almost impossible and, if the platform’s value was not already low enough, this lowers it even further. It gets worse in voice
                chats filled with pompous individuals, often behaving like entitled brats who change their character every other minute depending on who enters the room. When this kind of unstable and
                performative behaviour is repeatedly encouraged, it can reinforce unhealthy social habits and potentially contribute to existing mental-health difficulties. These same people then enter wider
                society seeking further leniencies and privileges, creating even more friction within real-world social systems.
              </p>
              <p>
                We also recognise males practically gobbling their microphones in an attempt to make their voices sound deeper and more authoritative, all for the purpose of attaining some form of false
                dominion. Then let’s not forget those servers where females are placed on a pedestal, socially conditioning male members into believing they have little to no self-worth unless they gain female
                approval. This reduces males to a lower-class mockery and further feeds the explosion of simp culture within society.
              </p>
              <p>
                The opposite edge of that same sword reveals communities that encourage the devaluation of females, creating clusters of women who become increasingly distrustful of, or lose faith in, their
                male counterparts. Both extremes create the same underlying problem. One side teaches men to devalue themselves in pursuit of women, while the other teaches women to devalue men altogether.
                Neither produces healthy relationships, genuine confidence or meaningful human connection.
              </p>
              <p>
                Males who are hit with this double-edged sword are left with choices. Submit and comply with the status quo, leading to further empowerment of toxic femininity. Rebel and directly fight back
                against the status quo, increasing toxic masculinity and leading to further empowerment of what is known as the manosphere. They could also refuse and withdraw from it all completely,
                potentially leading to further isolation and feeding the very social conditions associated with incel communities.
              </p>
              <p>
                All of these problems can ultimately be summarised by three underlying failures: a lack of social accountability, illogical management and the compartmentalising trap of society.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "low-calibre-automations"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("low-calibre-automations");
              }
            }}
          >
            <summary>Low Calibre Automations</summary>
            <div className="about-problem-content">
              <p>
                Analysing small to medium-sized communities reveals that administrators often use far too many bots; in some cases, there are more bots than humans. This does not look good visually, and those
                damn bots are always somehow involved in the conversation.
              </p>
              <p>
                Discord itself is generally intended for users aged thirteen and above, subject to local age requirements. Yet many bots operating across Discord and similar platforms are still aesthetically
                designed in ways that appear to appeal to much younger children. Baby Shark bots, turtle plushie bots, anime girl bots. It is all so cute and cuddly, isn’t it? Almost as if some of them were
                developed specifically to appeal to seven- or eight-year-old children.
              </p>
              <p>
                This leaves you with a lot of confusion. These same bots can also appear among those championed by the platforms they belong to. The issue is that you do not necessarily want anime girls and
                cuddly crustaceans controlling important elements of your setup.
              </p>
              <p>
                Following this, you may also notice that many servers which fall victim to raids have been compromised through abused trust, weak permissions or the misuse of particular bots. This makes
                misplaced trust in third-party automation a genuine security concern.
              </p>
              <p>
                Taking further notes, you also find that many bots are constantly pushing users towards monetary payments, usually through some form of premium service. There is so much begging for money that
                you begin to feel like a parent being financially violated by their own children.
              </p>
              <p>
                By this point, several problems have already been highlighted: an overload of single-focus bots, misplaced trust, childish visuals and lazy or overly profit-driven developers.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "integration-interruptions"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("integration-interruptions");
              }
            }}
          >
            <summary>Integration Interruptions</summary>
            <div className="about-problem-content">
              <p>
                You also observe the segregation of global society through ongoing forms of social engineering. Those we trust in prominent positions may support such segregation and, in some cases, even take
                part in shaping it. You therefore find yourself trapped in a constant loop of political correctness.
              </p>
              <p>
                You witness a fleet of movements all appearing to steer towards the division of the human population, whether purposely and intentionally or merely as the natural consequence of policies
                enforced by elites who failed to see the bigger picture. You realise that these movements are almost always packaged as helping different collectives gain equal rights.
              </p>
              <p>
                Yet rights movements can run into problems once they have achieved, or nearly achieved, equal treatment. A community originally created to fight unfair treatment can then become increasingly
                dependent on keeping people focused on the same differences it originally wanted society to move beyond in order to maintain its influence over the people within those communities.
              </p>
              <p>
                Any multicultural society risks becoming less integrated when protecting every group’s right to maintain its own identity gradually allows communities to build increasingly separate social
                worlds. The more separate those communities become, the greater the likelihood that their beliefs will come into conflict with one another and, ultimately, into conflict with the very
                foundational rules that originally allowed them all to coexist.
              </p>
              <p>
                As you become more knowledgeable and more aware of your own perceptions, you eventually reach a revelation. You are trapped inside an unavoidable social paradox, ironically created by many of
                the same people who publicly declare human progression as their common purpose.
              </p>
              <p>
                As an intelligent person, it would be fair to say that these problems cannot be solved by using the same obsolete social intelligence that helped create those problems to begin with, whether
                knowingly or unknowingly.
              </p>
              <p>
                The underlying issues here are: a lack of foresight, minimal vision, limited inclusion and short-term focus.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "systematic-social-deviation"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("systematic-social-deviation");
              }
            }}
          >
            <summary>Systematic Social Deviation</summary>
            <div className="about-problem-content">
              <p>
                A big problem exists across parts of the public sector, including social workers, teachers, civil servants and police officers, where it sometimes appears that the people entrusted with
                public-service responsibilities do not actually live out the mission statements and professional values they pledged to embody.
              </p>
              <p>
                Place social work under the spotlight and you discover documented points of failure. Concepts such as disguised compliance and disguised non-compliance demonstrate how complicated the
                relationship between professionals and service users can become, particularly within child protection.
              </p>
              <p>
                The danger begins when professional suspicion becomes so dominant that almost any response from the parent can be interpreted negatively. If you reject a social worker's narrative because you
                believe it is wrong, you risk being documented as uncooperative, combative or resistant. If instead you accept that narrative simply to avoid conflict, attention can then become focused on
                fixing a problem that may never have existed, causing intervention to drift further away from the real issues that originally needed addressing.
              </p>
              <p>
                Go further and fully cooperate, becoming deliberately agreeable and helpful, and even that can sometimes be interpreted suspiciously as excessive compliance or an attempt to conceal something.
                Stand firmly and confidently when challenging an inaccurate interpretation and assertiveness can be documented as aggression.
              </p>
              <p>
                This creates an almost inescapable frame. Social workers can sometimes approach families already carrying a professional hypothesis that something is wrong. A hypothesis is supposed to be
                tested against evidence, but when suspicion becomes the starting assumption, the family's behaviour can instead be interpreted through that assumption.
              </p>
              <p>
                Disagreement confirms resistance. Cooperation can confirm disguised compliance. Frustration confirms hostility. Withdrawal confirms unwillingness to engage.
              </p>
              <p>The result is a self-reinforcing cycle of distrust.</p>
              <p>
                Families who repeatedly feel misunderstood or treated with suspicion may eventually disengage from the service altogether. Yet that disengagement can then itself be documented as an even
                greater concern, strengthening the very narrative that caused the family to withdraw in the first place.
              </p>
              <p>
                The danger is therefore not simply that a social worker might make an incorrect assessment. Everyone can make mistakes. The greater danger appears when the professional framework makes that
                mistake increasingly difficult to challenge because almost every possible response from the family can be interpreted as further evidence supporting it.
              </p>
              <p>
                This problem becomes even more serious when the person caught inside the system is a child without an effective parent, guardian or independent advocate to challenge what is being written
                about them. An adult may at least have the confidence, language and independence to question an inaccurate professional narrative. A child may have none of those protections.
              </p>
              <p>
                The same system can decide where they live, who cares for them, what support they receive and how their behaviour is interpreted, while also creating the records that influence those decisions.
                If the child becomes angry, withdrawn or refuses to engage, that behaviour may be documented as the problem rather than understood as a response to feeling unheard or powerless.
              </p>
              <p>
                Without a trusted adult capable of challenging those interpretations, the professional version of events can gradually become more powerful than the child's own account of their life.
              </p>
              <p>
                This is why genuinely independent advocacy is so important: a child should never be expected to challenge the very system they depend upon for protection entirely on their own.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "mobility-madness"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("mobility-madness");
              }
            }}
          >
            <summary>Mobility Madness</summary>
            <div className="about-problem-content">
              <p>
                Inequality becomes obvious when observing the everyday lives of people with physical impairments, particularly those who have limited mobility and depend upon wheelchairs or mobility devices
                to navigate society.
              </p>
              <p>
                Companies and public organisations proudly advertise themselves as “wheelchair accessible” because they installed a ramp, wider doorway or elevator inside their building. Yet accessibility
                does not begin at the entrance of the building. A wheelchair user must first somehow reach that supposedly accessible building.
              </p>
              <p>
                They must travel across pavements obstructed by parked cars, bins, street furniture and poorly positioned signs; negotiate broken or uneven surfaces; search for dropped kerbs; cross roads
                designed primarily around vehicles; and sometimes travel considerably further simply because the most direct route cannot accommodate their chair.
              </p>
              <p>
                Government guidance itself recognises that accessible streets require well-maintained pavements, appropriately positioned dropped kerbs and navigable routes, while wheelchair users have
                reported pavement obstruction reducing their willingness or ability to travel independently.
              </p>
              <p>
                This exposes another example of tick-box accessibility. A company can install an elevator and declare the building wheelchair-friendly while ignoring the fact that the person using that
                wheelchair may have been forced through an obstacle course just to reach the front door.
              </p>
              <p>
                The Equality Act requires reasonable adjustments intended to reduce substantial disadvantage for disabled people, but genuine inclusion cannot be measured by one feature inside one building.
              </p>
              <p>
                Accessibility should mean being able to participate in society from the moment somebody leaves their home until the moment they return—not simply being able to move between floors once they
                somehow manage to arrive.
              </p>
              <p>
                If an able-bodied person can travel directly from A to B, while a wheelchair user must calculate whether the pavement is wide enough, whether a dropped kerb exists, whether the route is blocked
                and whether the destination can physically accommodate them, then both people may technically have the same right to enter society, but they clearly do not have the same practical freedom to
                navigate it.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "newskool-community-policing"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("newskool-community-policing");
              }
            }}
          >
            <summary>Newskool Community Policing</summary>
            <div className="about-problem-content">
              <p>
                Another problem becomes apparent within policing. Police officers responding to an incident usually do not know the people involved, the history between them or the full scope of what has
                happened.
              </p>
              <p>
                Their initial understanding may rely heavily on the information provided by the person who contacted them first, together with a short written summary, risk markers and whatever information
                has already been entered onto police systems.
              </p>
              <p>
                This means the first person to call the police can gain an immediate advantage by shaping the original narrative before officers have even arrived. This becomes more dangerous when somebody
                deliberately attaches themes such as racism, homophobia, threats or vulnerability to an allegation because they understand those words are likely to generate a faster or more serious response.
              </p>
              <p>
                These allegations should always be taken seriously, but taking an allegation seriously is not the same as treating it as proven fact.
              </p>
              <p>
                The danger appears when police arrive already influenced by the wording of the original report and begin viewing the person being accused through that frame before properly hearing both sides
                or establishing independent evidence.
              </p>
              <p>
                Police can therefore sometimes be used as unwitting pawns within somebody else's personal conflict. The officers themselves may have no dishonest intention at all. They may genuinely believe
                they are protecting somebody who appears vulnerable. The weakness is that the person who created the original report may understand how to trigger that protective response and use it against
                somebody else.
              </p>
              <p>
                This can also be used to trigger a heavier response to domestic incidents, where partners are engaged in an argument and one partner attempts to use the same flawed process against the other.
              </p>
              <p>
                Modern policing also appears increasingly driven by paperwork, computer systems, risk assessments and short recorded summaries. These systems are useful for accountability and safeguarding,
                but they can never replace actually knowing the people and communities being policed.
              </p>
              <p>
                There were periods when many communities had far more visible local officers who regularly walked the same areas and became familiar with the people living there. They knew which families
                were constantly arguing, which neighbours repeatedly complained about each other, who was genuinely vulnerable and which incidents formed part of a much wider history.
              </p>
              <p>
                As neighbourhood policing became less visible in many areas and police work became increasingly centralised and administrative, much of that human context risked being lost.
              </p>
              <p>
                An officer today may arrive knowing several things that have been written about a person while knowing almost nothing about the actual person standing in front of them.
              </p>
              <p>The danger begins when recorded information becomes more powerful than human understanding.</p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "persistent-financial-hardship"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("persistent-financial-hardship");
              }
            }}
          >
            <summary>Persistent Financial Hardship</summary>
            <div className="about-problem-content">
              <p>
                You can see another contradiction when looking at DWP Work Coaches. The role is supposed to be centred around people. Work Coaches are there to listen, understand individual circumstances,
                motivate people, recognise their skills and barriers, and help them move towards employment and greater financial independence.
              </p>
              <p>
                DWP itself describes the role as one involving mentoring, coaching and providing support tailored to the individual. Yet from what I have witnessed, some of the people occupying these roles
                appear to lack the very people skills the job depends upon.
              </p>
              <p>
                Some struggle to communicate confidently, seize opportunities within conversations, inspire people or even demonstrate the empathy and understanding their own public-service standards
                require.
              </p>
              <p>
                This creates an obvious question: how can somebody successfully prove these qualities during the recruitment process and then appear unable or unwilling to demonstrate them when dealing with
                the actual public?
              </p>
              <p>
                There can also be an insider advantage surrounding Civil Service recruitment, although this should not be confused with evidence that DWP deliberately prefers applicants whose relatives
                already work there. Civil Service appointments are legally required to be based on merit through fair and open competition.
              </p>
              <p>
                However, somebody with family or close connections already inside the Civil Service may naturally gain informal knowledge about competency frameworks, behaviours, application wording and
                interview techniques that an equally capable outsider has never encountered.
              </p>
              <p>
                The danger is that people can become exceptionally good at passing the recruitment system without necessarily being exceptional at performing the human purpose of the job.
              </p>
              <p>
                There is also something visibly noticeable within communities: Civil Service employment can appear to cluster within families. It is not unusual to encounter households where several
                relatives work, or have worked, within government rather than just one isolated family member.
              </p>
              <p>
                That observation does not by itself prove that the Civil Service deliberately recruits relatives of existing employees, but it does raise an important question about informational advantage.
              </p>
              <p>
                A person growing up around existing civil servants can gain knowledge of how the application process works, what the behavioural framework expects, how competency examples should be presented
                and what particular language succeeds at interview. An equally capable outsider may encounter that unusual recruitment system completely cold.
              </p>
              <p>
                Civil Service research itself acknowledges the importance of institutional networks, unwritten behavioural codes and access to people who understand how to navigate the organisation.
              </p>
              <p>The result can therefore become a form of occupational inheritance.</p>
              <p>
                This matters because a Work Coach should be much more than an administrator sitting behind a desk. The role should require the ability to communicate, motivate, build confidence, recognise
                potential and understand why somebody is struggling to move forward.
              </p>
              <p>
                Yet some claimants experience the opposite: being spoken down to, processed through appointments and treated more like administrative cases than individual people.
              </p>
              <p>
                There is also a danger when the role itself becomes valued primarily because it provides a stable Civil Service salary, pension, security and career progression rather than because somebody
                genuinely wants to help other people progress.
              </p>
              <p>
                Nobody can know another worker's private motivation simply by observing them, and many Work Coaches undoubtedly care deeply about the people they support. But public service deteriorates when
                obtaining the position becomes more important than living out the mission statement.
              </p>
              <p>
                Another question emerges when public organisations heavily emphasise diversity and equal representation. Diversity itself does not demonstrate that somebody was recruited without merit, and
                an individual's ethnicity should never be treated as evidence that they are merely filling a quota. The responsibility instead belongs to the organisation to ensure that its recruitment
                systems remain demonstrably fair, merit-based and transparent.
              </p>
              <p>
                Without that transparency, a damaging situation can emerge where qualified recruits themselves become unfairly questioned because the organisation appears more focused on presenting visual
                diversity than explaining the standards by which every applicant was selected.
              </p>
              <p>
                The issue therefore should never be whether somebody “looks different”. The issue is whether every person recruited can demonstrate the skills required to perform the role effectively.
              </p>
              <p>
                A Work Coach should never become merely an office worker who checks whether the claimant has completed enough tasks. They should be the people capable of recognising potential that the
                claimant themselves may not yet recognise.
              </p>
              <p>
                Otherwise, the Jobcentre risks becoming another public institution where the paperwork proves that the mission is being completed while the human experience demonstrates that the mission
                itself has been forgotten.
              </p>
              <p>
                Some responsibility must also sit above the individual Work Coach and be placed on the team leaders responsible for developing them.
              </p>
              <p>
                The founder of Pogforts, Paul Frederick David Walsh, has a background in successfully leading executive sales teams. One of the leadership principles he applies is that when an executive
                repeatedly fails, responsibility should not automatically be placed entirely upon the team member. Leadership must also examine whether that individual was correctly trained, coached,
                motivated and supported.
              </p>
              <p>
                It is clearly the duty of any leader to identify weakness, strengthen the team and remain true to the mission statement.
              </p>
              <p>
                Mr Walsh also argues that it is the duty of executives at every level to increase the faith and motivation of customers, clients, claimants and fellow executives interchangeably.
              </p>
              <p>
                Work Coaches have also reported working at such a fast pace that time pressures can make genuinely personalised support extremely difficult.
              </p>
              <p>
                Another major weakness is the practice of passing claimants between different Work Coaches. Employment support depends heavily upon understanding the individual: their personality, skills,
                employment history, barriers, confidence and ambitions.
              </p>
              <p>Every time that person is passed to somebody new, much of that understanding has to be rebuilt.</p>
              <p>Reflecting on his years as a sales executive, Mr Walsh states:</p>
              <p>
                “There is no way I would just pass one of my clients over to another member of staff. When I've done all the leg work, the client trusts me and we already have an established bond. The client
                keeps promises to me and maintains engagement with me because of that conduct.”
              </p>
              <p>In management terms, this is a failure of ownership.</p>
              <p>
                If one Work Coach takes responsibility for understanding a claimant's journey, they can recognise progress, notice changes, remember previous conversations and adapt their approach over time.
              </p>
              <p>
                When responsibility is constantly passed around the office, the claimant risks becoming everybody's appointment but nobody's responsibility.
              </p>
              <p>The Jobcentre then begins managing a claim rather than developing a person.</p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "teaching-bad-habits"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("teaching-bad-habits");
              }
            }}
          >
            <summary>Teaching Bad Habits</summary>
            <div className="about-problem-content">
              <p>
                An issue is evident in public high schools through publicly displayed mission statements that are not always executed by staff members.
              </p>
              <p>Statements similar to, “As friends, we share our gifts and talents to support one another and build a better world.”</p>
              <p>
                Every school has some form of statement like this, expressed through different variations, yet these statements are not always lived up to. In fact, this has become so normalised that parents
                do not even take a school’s mission statement seriously, and neither do some members of the school faculty.
              </p>
              <p>It becomes just another empty slogan.</p>
              <p>
                You may witness these contradictions becoming even greater in religiously inspired schools, such as Catholic or Muslim schools, amongst others. They may publicly claim things like, “We are
                here to combat materialism and spiritual emptiness.”
              </p>
              <p>
                Yet within the same schools, headteachers can appear so focused on acquiring status, manipulating themselves into higher positions and presenting themselves through expensive suits and
                appearances that they seem more concerned with status than with managing and supporting children.
              </p>
              <p>
                In a capitalist system—an economy largely built around acquiring, producing and consuming material goods—how can you legitimately support the claim, “We are here to combat materialism and
                spiritual emptiness,” when these same schools promote ranking systems and the purchasing of materials that themselves stimulate a capitalist economy?
              </p>
              <p>
                This only further reinforces the point about false claims, and in this particular case it is a claim that appears almost impossible to achieve within the very structure in which the school
                operates.
              </p>
              <p>
                These types of words can become little more than space fillers when there is no obvious intent to actually execute the mission behind them.
              </p>
              <p>So, if parents, students and school faculty already know that these public statements are bogus, why do we continue to accept them?</p>
              <p>Are we literally grooming generations during their development to accept that mission statements do not actually mean anything?</p>
              <p>Are parents too busy, too disengaged or too afraid to speak about such easily discredited claims?</p>
              <p>
                Moving on, we then have members of the faculty themselves who, in some cases, disrespect their students while prioritising the task of pleasing their superiors, such as the headteacher. This
                takes place within an environment where young adults are observing such behaviour and potentially learning to accept it as normal.
              </p>
              <p>
                You will also find real case studies involving staff whose behaviour has been alleged to cross professional boundaries, including inappropriate sexualised conduct and, in the most serious
                circumstances, allegations of grooming. These accusations should obviously be distinguished from proven misconduct, but their existence reinforces why safeguarding standards and independent
                accountability are so important within environments that are supposed to be safe and trusted.
              </p>
              <p>
                One specific case study concerns an office administrator at one school who acquired the role of Head of Pastoral and Safeguarding. This effectively moved her from carrying out relatively
                limited social-support responsibilities to assuming responsibility for some of the most significant welfare and safeguarding duties within the school, and this is an important factor within
                the case study.
              </p>
              <p>
                According to accounts from students familiar with the situation, the same faculty member was observed disregarding some students' needs while handling much of her role through office-based
                duties. Students also reported observing conduct involving dating apps and other personal adult activities within the school environment.
              </p>
              <p>
                These accounts matter because the same faculty member was responsible for referring students to intervention services and mental-health support.
              </p>
              <p>
                One difficult student was referred to mental-health support outside of the school, from which the student benefited greatly. However, the support provided was only short in duration and
                eventually had to come to an end.
              </p>
              <p>
                There are significant waiting lists for this type of support, although the process can sometimes be accelerated slightly through a school referral.
              </p>
              <p>
                During the student's final visit, her mental-health support counsellor reportedly told her that, if she wished to return for further support, she could do so, but would need to go through the
                correct channels.
              </p>
              <p>When the student later approached the Head of Pastoral for another referral, the student reports being told:</p>
              <p>“No, you don’t need that. There’s nothing wrong with you.”</p>
              <p>If accurately reported, this response was unacceptable.</p>
              <p>
                According to information provided within this case study, students who are referred to mental-health services may routinely be asked about their family and school life, including their
                lessons, peers, teachers and other members of faculty.
              </p>
              <p>
                When the counsellor was informed about mistreatment allegedly occurring at the hands of some faculty members, together with concerns regarding the behaviour of the Head of Pastoral, the
                student was informed of her rights.
              </p>
              <p>
                The mental-health support counsellor was also reported to have raised concerns about what they considered to be an unprofessional attitude and possible negligence.
              </p>
              <p>
                Where allegations of this seriousness are made, they must obviously be independently verified before being treated as established fact. However, the wider point remains: a safeguarding
                structure loses credibility when the people responsible for protecting children are themselves insulated from meaningful scrutiny.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "solutions-need-solutions"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("solutions-need-solutions");
              }
            }}
          >
            <summary>Solutions Need Solutions</summary>
            <div className="about-problem-content">
              <p>
                A problem becomes apparent after listing all the problems documented throughout our journey, and that is that there are not really any fully established solutions for the majority of them.
              </p>
              <p>
                People within the communities that together make up our global society often choose to exist as single entities rather than as a united entity that provides support for one another.
              </p>
              <p>Simply put, if we force the philosophy onto society that “it’s a dog-eat-dog world,” then unfortunately, we all get eaten.</p>
              <p>Competition, and the honour of it, is a beautiful thing.</p>
              <p>But blind savagery and the inability to see beyond ourselves only create a world built to consume itself.</p>
              <p>It should be obvious that every single human being contributes to how our world manifests as a global collective.</p>
              <p>
                We do see independent organisations formed that attempt to address social and economic issues. However, they are often weak in their attempts, while others are simply not supported to the
                necessary level or are founded by people who do not possess the required skillset to achieve their projected outcomes.
              </p>
              <p>
                There are also many communities that spawn, some of which are targeted towards adults and some towards children. Though, to their credit, some of these communities can reduce opportunities
                for crime to some extent by providing distractions, structure and positive activities, even at their bare minimum capacities.
              </p>
              <p>
                We also have communities that are government-funded. Some appear able to gain support partly through the salesmanship of their founders. A basic business plan is formed, a generic mission
                statement is generated, employment is created for those operating the organisation, and government funding can then be used to sustain salaries and services.
              </p>
              <p>
                There is nothing inherently wrong with somebody being paid to perform genuine community work. The question becomes whether the outcomes being funded actually justify the structure built
                around them.
              </p>
              <p>
                These communities can go by vague names of egotistical intent, names similar to “We The Best Community.” Such names sound more like they are promoting DJ Khaled than they do the elevation of
                society.
              </p>
              <p>It is then no surprise when some of these communities amount to little more than glorified youth clubs.</p>
              <p>We could ask the question: would the founders of those communities still be interested in supporting you if doing so did not provide them with government funding?</p>
              <p>
                However, the answer to that question can sometimes already be found within the chronological pattern of events and the actions that follow them.
              </p>
              <p>
                In any event, a youth club is good for distracting children, keeping them occupied and potentially reducing opportunities for crime.
              </p>
              <p>
                But where the founders and owners of those youth clubs appear to prefer glorifying themselves above all else, evidence of that priority can often be found within their own actions.
              </p>
              <p>
                Another issue then develops because, when you focus only on children, not only can you take children away from their parents for significant periods of time—which can, in some cases, create
                household friction—but the adults themselves also escape the net.
              </p>
              <p>On top of this, if those adults are also parents, their children will naturally continue to align themselves with them.</p>
              <p>
                This can create further problems for the social and economic design of those communities, leading to extended problems, failed missions and wasted government funds.
              </p>
            </div>
          </details>

          <details
            className="about-problem-node"
            open={openProblem === "transparency-illusion"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenProblem("transparency-illusion");
              }
            }}
          >
            <summary>Transparency Illusion</summary>
            <div className="about-problem-content">
              <p>A final recurring problem is what can be described as The Transparency Illusion.</p>
              <p>
                Small companies, multinational corporations, charities, government departments and public organisations all love using the word “transparent”. They publicly promise transparency,
                accountability and open communication as though simply declaring these words automatically makes them true.
              </p>
              <p>
                Yet when you actually examine how this transparency is presented, you often discover that the organisation itself still controls exactly what you are allowed to see.
              </p>
              <p>This creates an obvious contradiction.</p>
              <p>
                Genuine transparency should mean allowing people to clearly understand how decisions are made, where money goes, who holds responsibility, what mistakes have occurred and what actions were
                taken afterwards.
              </p>
              <p>
                Instead, what we are commonly given is selective transparency: polished reports, carefully worded statements, controlled statistics, generic policies and public information that reveals
                enough to create the appearance of openness without necessarily exposing anything that could seriously challenge the organisation itself.
              </p>
              <p>This becomes even more complicated within large corporate structures.</p>
              <p>
                Many corporate groups are built through chains of holding companies, subsidiaries and parent companies, where one company owns another company, which may itself own another company,
                eventually leading down to the gateway-level company that the ordinary customer actually interacts with.
              </p>
              <p>
                There can be perfectly legitimate commercial reasons for these structures, but the effect is still one of compartmentalisation.
              </p>
              <p>
                Responsibility becomes spread across separate legal entities, ownership becomes harder for the average person to follow, and accountability can become increasingly difficult to trace several
                layers above the company whose name appears on the website, receipt or contract.
              </p>
              <p>
                When something goes wrong, the customer may believe they are dealing with one organisation, only to discover that the brand is operated by one company, owned by another, financed through
                another, holding intellectual property through another and ultimately controlled somewhere further up the chain.
              </p>
              <p>Each entity may be legally separate, with different responsibilities and liabilities.</p>
              <p>
                This can create a corporate maze where everybody appears connected when profits and branding are concerned, yet suddenly becomes separate when responsibility needs to be established.
              </p>
              <p>That is where compartmentalisation can begin to work against transparency.</p>
              <p>The question “Who actually owns this?” may require several searches.</p>
              <p>The question “Who made this decision?” may produce no clear individual answer.</p>
              <p>
                The question “Who is accountable?” can result in responsibility being passed backwards and forwards between departments, contractors, subsidiaries and parent companies until the person asking
                eventually gives up.
              </p>
              <p>A company may proudly publish a transparency report while withholding important information under commercial confidentiality.</p>
              <p>
                A public body may promote openness while responding to difficult questions with restricted information, complicated procedures or carefully constructed language that says a great deal without
                actually answering anything.
              </p>
              <p>
                Smaller organisations can behave exactly the same way, publicly displaying rules and decisions while keeping the reasoning, internal conversations and responsibility behind those decisions
                completely out of sight.
              </p>
              <p>The illusion becomes even stronger because simply making information available does not necessarily make something transparent.</p>
              <p>
                Hundreds of pages of policies, annual reports, corporate filings, statistics, legal wording and organisational charts can technically be public while remaining almost impossible for an
                ordinary person to understand.
              </p>
              <p>Visibility is not the same as clarity.</p>
              <p>
                Flooding the public with information can therefore create the appearance of transparency while still preventing people from seeing the bigger picture.
              </p>
              <p>There is also the question of who controls the narrative when something goes wrong.</p>
              <p>
                Organisations are often extremely transparent when discussing their successes, awards, investments, diversity figures, profits and projected achievements.
              </p>
              <p>
                Yet the language suddenly becomes far more cautious when discussing failures, complaints, wasted money, internal misconduct or decisions capable of damaging their reputation.
              </p>
              <p>
                Transparency therefore risks becoming another public-relations tool: open when the information makes you look good, compartmentalised when responsibility becomes uncomfortable, and
                restricted when the information threatens the organisation itself.
              </p>
              <p>This is why the word “transparent” should never be accepted as evidence of transparency.</p>
              <p>
                An organisation telling you it is transparent proves little more than the fact that it understands transparency is something the public values.
              </p>
              <p>
                The real test is whether an ordinary person can follow the chain of ownership, understand who made a decision, identify who carries responsibility and obtain meaningful information when
                something has actually gone wrong.
              </p>
              <p>True transparency does not mean showing the public everything you want them to see.</p>
              <p>It does not mean hiding accountability behind five companies simply because all five can technically be found on a public register.</p>
              <p>And it certainly does not mean overwhelming people with so much fragmented information that the truth becomes harder to locate rather than easier.</p>
              <p>True transparency means making ownership, decision-making and responsibility clear enough that accountability cannot simply disappear into the structure.</p>
            </div>
          </details>
        </div>
      </section>
      <h1 className="about-centred-heading">Problems 2 Purpose</h1>
      <p>
        Many problems have been encountered on our journey through online communities, public institutions, social systems, accessibility, policing, employment support, education, corporate
        structures and the everyday behaviour of human beings.
      </p>
      <p>Though you have likely spotted a lot of recurring themes.</p>
      <p>
        You may have even realised that some of our problems overlap, most actually connect in some way, and usually the source can be traced back to an imbalance within an ongoing “system versus
        social” dilemma.
      </p>
      <p>That's a good thing for us, because it turns the complicated job of providing effective solutions into light work.</p>
      <p>
        You'll understand that apparently separate problems repeatedly emerge from the same underlying weaknesses. Poor accountability, weak leadership, compartmentalisation, short-term thinking,
        insufficient human understanding and systems drifting away from the people they were originally created to serve. you no longer need a completely different philosophy for every individual
        problem.
      </p>
      <p>You need a better foundation; a better blueprint. </p>
      <p>The truth is that we could never visibly see the light without first seeing the dark.</p>
      <p>This has since become our key philosophy moving forward.</p>

      <p>
        One great man Søren Kierkegaard recognised that life can only be understood backwards, even though it must be lived forwards. The legendary Manly P. Hall approached human progress through
        a similar principle, repeatedly looking backwards through history, philosophy and human experience to understand the causes shaping the present. Problems 2 Purpose(P2P) follows that same logic:
        before we attempt to build what comes next, we first study what came before, understand where it failed, preserve what worked, and use that knowledge to create something better.
      </p>

      <h1 className="about-centred-heading">Our Mission</h1>
      <p>We believe leaders like ourselves are here to serve the community, not for the community to serve us. Pogforts exists to turn Problems 2 Purpose. We study the systems, environments and 
        behaviours around us, identify where they fail the people they were created to serve, preserve what works, challenge what does not, and use that understanding to create something better.
      </p>
      <p>
        Our mission is not to claim that we can solve every problem in society. That would simply become another empty mission statement. Our mission is to recognise the problems within our reach and 
        actively compete against them through better leadership, stronger community, intelligent technology, meaningful human interaction, accountability, accessibility, education, creativity and continuous adaptation.
      </p>

      <ul className="about-mission-list">
        <li>We only use automations to perform administration tasks which allows us to focus obsessively on important human elements.</li>
        <li>We govern using old school policing; being active at all levels and genuinely knowing the people that make up our community.</li>
        <li>We leverage our knowledge to develop key skills and hidden abilities with intent of inspiring independence that empowers the individual.</li>
        <li>We remain fully remote, providing us global reach, opportunity for the physically impaired and countering crisis such as pandemics.</li>
        <li>We treat our mission statement as an oath we swear by, making any deviation from our promise incredibly difficult and publicly known.</li>
      </ul>

      <section className="about-living-panel">
        <h1>Living The Statement</h1>
        <p>
          A mission statement means very little if it only exists as words on a page. If Pogforts is going to challenge systems and organisations for failing to live by the principles they publicly
          promote, then we must hold ourselves to exactly the same standard.
        </p>
        <p>
          Living The Statement documents what we are actively doing now to turn our philosophy into practice. These are the systems, decisions and working principles through which Pogforts puts
          Problems 2 Purpose into active duty.
        </p>

        <div className="about-living-tree">
          <details
            className="about-living-node"
            open={openLivingStatement === "community-before-numbers"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("community-before-numbers");
              }
            }}
          >
            <summary>Community Before Numbers</summary>
            <div className="about-living-content">
              <p>
                Pogforts is built around participation rather than simply collecting members. Our Discord community, houses, games, rankings, challenges, events and creative projects give people
                reasons to actually take part instead of existing as another number inside a server list.
              </p>
              <p>
                We would rather create a smaller environment where participation carries meaning than manufacture the appearance of success through inflated statistics. Activity should be the
                result of value being created for the community, not the purpose of the community itself.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "human-led-automation"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("human-led-automation");
              }
            }}
          >
            <summary>Human-Led Automation</summary>
            <div className="about-living-content">
              <p>
                Magical Sorting Bat is developed as a central Pogforts system rather than another disconnected bot competing for attention. MSB supports community functions, interactive commands,
                game mechanics, voice features, moderation-supporting tools and other services used throughout the ecosystem.
              </p>
              <p>
                Our principle is simple: automation should support people; people should never exist merely to support the automation. Human judgement, context and community experience remain more
                important than allowing an automated system to become the purpose of the environment it was created to assist.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "one-connected-ecosystem"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("one-connected-ecosystem");
              }
            }}
          >
            <summary>One Connected Ecosystem</summary>
            <div className="about-living-content">
              <p>
                Pogforts is operated as a connected digital environment. The Pogforts Discord server, pogforts.uk, Magical Sorting Bat, Murder Mystery Magic, account features, leaderboards and
                community systems are built to work as parts of the same wider ecosystem rather than as unrelated products with no common direction.
              </p>
              <p>
                Bringing systems together reduces unnecessary compartmentalisation and gives us more control over how the experience develops. When one part of Pogforts changes, we can consider
                how that change affects the rest of the environment instead of treating every feature as an isolated problem.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "competition-with-purpose"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("competition-with-purpose");
              }
            }}
          >
            <summary>Honourable Competition</summary>
            <div className="about-living-content">
              <p>
                Competition is deliberately built into Pogforts through houses, rankings, challenges and community games. We believe competition can create identity, progression, loyalty, humour and
                achievement without requiring the people involved to stop belonging to the same wider community.
              </p>
              <p>
                The objective is not blind hostility. It is to give rivalry a purpose: something that motivates participation, rewards development and creates memorable shared experiences while
                keeping everybody connected to the same environment.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "leadership-with-ownership"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("leadership-with-ownership");
              }
            }}
          >
            <summary>Leadership With Ownership</summary>
            <div className="about-living-content">
              <p>
                Our leadership principle is that leaders are here to serve the community, not for the community to serve them. Authority therefore creates responsibility rather than exemption from
                responsibility. The standards expected from members must also matter when decisions are being made by the people operating Pogforts.
              </p>
              <p>
                When something does not work, we examine the system, the design, the communication and the leadership around it instead of automatically blaming the person at the bottom. Ownership
                means accepting that strengthening an environment is part of the leader's job.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "accessibility-by-design"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("accessibility-by-design");
              }
            }}
          >
            <summary>Accessibility By Design</summary>
            <div className="about-living-content">
              <p>
                Pogforts is built for use across different screen sizes and devices, with layouts and interfaces designed to adapt rather than forcing every person into one fixed method of access.
                Mobile, tablet and desktop presentation are treated as part of the same experience.
              </p>
              <p>
                We treat accessibility as an ongoing design responsibility rather than a single feature that can be added once and forgotten. If an interface creates unnecessary difficulty, the
                correct response is to examine the interface and adapt it.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "transparency-in-practice"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("transparency-in-practice");
              }
            }}
          >
            <summary>Transparency In Practice</summary>
            <div className="about-living-content">
              <p>
                Pogforts openly identifies its ownership and operation, provides public legal information and distinguishes Pogforts services from third-party platforms, assets and services where
                appropriate. We do not believe transparency is achieved simply by publishing large amounts of information.
              </p>
              <p>
                The objective is clarity: people should be able to understand who operates the environment, what belongs to Pogforts, where another service is involved and where responsibility sits.
                Transparency should make accountability easier to follow, not bury it underneath unnecessary complexity.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "learning-coaching-development"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("learning-coaching-development");
              }
            }}
          >
            <summary>Learning, Coaching &amp; Development</summary>
            <div className="about-living-content">
              <p>
                Development inside Pogforts is not limited to software. Our team combines technical development with teaching, coaching, problem solving and direct human collaboration. Knowledge is
                shared through the process of building, testing, explaining and improving the systems we use together.
              </p>
              <p>
                We treat mistakes and weaknesses as information that can be used for development. The objective is not to create an environment where people are expected to arrive already knowing
                everything; it is to create one where people and systems can improve through participation and constructive challenge.
              </p>
            </div>
          </details>

          <details
            className="about-living-node"
            open={openLivingStatement === "build-test-adapt"}
            onToggle={(event) => {
              if (event.currentTarget.open) {
                setOpenLivingStatement("build-test-adapt");
              }
            }}
          >
            <summary>Build, Test, Evolve</summary>
            <div className="about-living-content">
              <p>
                Pogforts is continuously developed through practical iteration. Features, interfaces, games and community systems are built, observed in use, refined and, where necessary, redesigned
                or retired rather than being protected simply because they already exist.
              </p>
              <p>
                This is the active form of our team philosophy: <strong>“Create it, adapt it, dynamic.”</strong> The landscape changes, so the systems operating within it must be capable of changing too.
                We treat adaptation as a permanent operating principle rather than an emergency response.
              </p>
            </div>
          </details>
        </div>
      </section>

      <section
        ref={roadmapSectionRef}
        className="about-roadmap-section"
        aria-labelledby="about-roadmap-title"
      >
        <h1 id="about-roadmap-title" className="about-centred-heading">ROADMAP</h1>
        <p>
          A mission needs direction. Our Roadmap provides a transparent view of the journey behind Pogforts, where we currently stand and the objectives that remain ahead. The destination gives us
          direction, but the route remains dynamic; as technology, communities and circumstances evolve, so will the path we take to reach it. Click or press each milestone on the roadmap for details of each.
          On mobiles or smaller devices you may scroll horizontally to access past and present destinations.
        </p>

        <div
          className={`about-roadmap-stage${roadmapJourneyActive ? " is-journey-running" : ""}${roadmapJourneyComplete ? " is-journey-complete" : ""}`}
          style={{ "--roadmap-scale": roadmapScale }}
        >
          <div
            ref={roadmapViewportRef}
            className={`about-roadmap-viewport${roadmapScrollMode ? " is-scroll-mode" : " is-fit-mode"}${!roadmapJourneyComplete ? " is-journey-locked" : ""}`}
            onPointerDownCapture={() => {
              if (!roadmapJourneyComplete) {
                showRoadmapPleaseWait();
              }
            }}
            onWheel={(event) => {
              if (
                !roadmapJourneyComplete &&
                Math.abs(event.deltaX) > Math.abs(event.deltaY)
              ) {
                event.preventDefault();
                showRoadmapPleaseWait();
              }
            }}
            onScroll={() => {
              roadmapLastScrollAtRef.current = Date.now();

              if (!roadmapJourneyComplete) return;

              const gesture = roadmapGestureRef.current;
              const viewport = roadmapViewportRef.current;
              if (gesture && viewport && Math.abs(viewport.scrollLeft - gesture.startScrollLeft) > ROADMAP_SWIPE_THRESHOLD) {
                gesture.moved = true;
              }
            }}
            aria-label="Pogforts development roadmap"
            aria-busy={!roadmapJourneyComplete}
          >
            <div
              className="about-roadmap-track"
              style={{
                "--roadmap-scale": roadmapScale,
                "--roadmap-track-width": `${ROADMAP_DESIGN_WIDTH * roadmapScale + roadmapEdgePadding * 2}px`,
                "--roadmap-edge-padding": `${roadmapEdgePadding}px`,
              }}
            >
              <div className="about-roadmap-nodes">
                <div className="about-roadmap-route" aria-hidden="true">
                  <span
                    className="about-roadmap-route-complete"
                    style={{ width: `${roadmapJourneyProgressPercent}%` }}
                  />
                </div>

                {roadmapMilestones.map((milestone, index) => {
                  const isCurrent = milestone.status === "current";
                  const isJourneyLit = roadmapJourneyComplete
                    ? milestone.status !== "future"
                    : index <= roadmapJourneyReachedIndex;

                  return (
                    <button
                      key={milestone.id}
                      ref={(node) => {
                        roadmapMilestoneRefs.current[index] = node;
                        if (isCurrent) roadmapCurrentRef.current = node;
                      }}
                      type="button"
                      className={`about-roadmap-milestone is-${milestone.status}${isJourneyLit ? " is-journey-lit" : ""}${roadmapJourneyComplete ? " is-journey-complete" : ""}`}
                      aria-label={`Open ${milestone.title} roadmap milestone, ${milestone.status}`}
                      aria-current={isCurrent ? "step" : undefined}
                      aria-disabled={!roadmapJourneyComplete}
                      onPointerDown={(event) => {
                        if (!roadmapJourneyComplete) return;

                        roadmapGestureRef.current = {
                          startX: event.clientX,
                          startScrollLeft: roadmapViewportRef.current?.scrollLeft || 0,
                          moved: false,
                        };
                      }}
                      onPointerMove={(event) => {
                        if (!roadmapJourneyComplete) return;

                        const gesture = roadmapGestureRef.current;
                        if (gesture && Math.abs(event.clientX - gesture.startX) > ROADMAP_SWIPE_THRESHOLD) {
                          gesture.moved = true;
                        }
                      }}
                      onClick={(event) => {
                        if (!roadmapJourneyComplete) {
                          event.preventDefault();
                          showRoadmapPleaseWait();
                          return;
                        }

                        const gesture = roadmapGestureRef.current;
                        const scrolledRecently = Date.now() - roadmapLastScrollAtRef.current < 120;
                        if (event.detail !== 0 && roadmapScrollMode && (gesture?.moved || scrolledRecently)) {
                          event.preventDefault();
                          roadmapGestureRef.current.moved = false;
                          return;
                        }

                        roadmapGestureRef.current.moved = false;
                        roadmapTriggerRef.current = event.currentTarget;
                        setActiveRoadmapMilestone(milestone);
                      }}
                    >
                      <span className="about-roadmap-node" aria-hidden="true" />
                      <span className="about-roadmap-label">
                        {milestone.label.map((line) => (
                          <span key={line}>{line}</span>
                        ))}
                      </span>
                      {isCurrent && roadmapJourneyComplete && (
                        <span className="about-roadmap-current-marker" aria-hidden="true">
                          <span className="about-roadmap-current-arrow" />
                          <span className="about-roadmap-current-text">WE ARE HERE</span>
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div
            className={`about-roadmap-journey-status${roadmapWaitVisible ? " is-visible" : ""}`}
            aria-live="polite"
            aria-atomic="true"
          >
            Please wait...
          </div>
        </div>
      </section>

      {activeRoadmapMilestone && (
        <div
          className="about-roadmap-modal-overlay"
          role="presentation"
          onPointerDown={(event) => {
            if (event.target === event.currentTarget) closeRoadmapModal();
          }}
        >
          <div
            ref={roadmapModalRef}
            className="about-roadmap-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="about-roadmap-modal-title"
            tabIndex={-1}
          >
            <div className="about-roadmap-modal-kicker">POGFORTS ROADMAP</div>
            <h2 id="about-roadmap-modal-title">{activeRoadmapMilestone.title}</h2>
            <p className="about-roadmap-modal-tagline">{activeRoadmapMilestone.tagline}</p>

            <div className="about-roadmap-modal-brief">
              {activeRoadmapMilestone.brief.map((paragraph, index) => (
                <p key={`${activeRoadmapMilestone.id}-brief-${index}`}>{paragraph}</p>
              ))}
            </div>

            <div className="about-roadmap-modal-meta">
              <div>
                MILESTONE {String(activeRoadmapMilestone.order).padStart(2, "0")} / {String(roadmapMilestones.length).padStart(2, "0")}
              </div>
              <div className="about-roadmap-modal-status">
                STATUS:{" "}
                <span className={`about-roadmap-status-word is-${activeRoadmapMilestone.status}`}>
                  {activeRoadmapMilestone.status}
                </span>
              </div>
            </div>

            <button type="button" className="about-roadmap-modal-close" onClick={closeRoadmapModal}>
              CLOSE
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default About;
